import { UnitTableFilters } from "./filter/UnitTableFilters";
import { UnitTableSort } from "./sort/UnitTableSort";
import type { UnitCategory, UnitFeature } from "@/types";

interface UnitTableControlsProps {
    features: UnitFeature[];
    categories: UnitCategory[];
}
export const UnitTableControls = ({
    features,
    categories,
}: UnitTableControlsProps) => {
    return (
        <div className="unit-table-controls tw:flex tw:flex-row tw:space-x-3 tw:items-end">
            <UnitTableFilters features={features} categories={categories} />
            <UnitTableSort />
        </div>
    );
};
